module.exports = __webpack_public_path__ + "static/media/krasnodar@2x.9f79c5ad.jpg";